module.exports = __webpack_public_path__ + "img/48.b067f2a8.png";